import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import servConsultaDisponibilidade from "../../services/login/servConsultaDisponibilidade";
import MapaDrawing from "../../components/MapaDrawing/MapaDrawing";
import servLogin from "../../services/login/servLogin";
import { faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ConsultaDisponibilidade = () => {
	const sidebarOpen = useSelector(state => state.sidebar.sidebarOpen);
	const drawerWidth = sidebarOpen ? 250 : 72;
	const [coordenadasLatLong, setCoordenadasLatLong] = useState({ lat: -28.67, lng: -49.37 });
	const [showDrawing, setShowDrawing] = useState(false);
	const [showMenssage, setShowMenssage] = useState(true);
	const [mapaLoaded, setMapaLoaded] = useState(false);
	const [parametros, setParametros] = useState({
		DisponibilizaMapas: 0,
        QtdeMaximaDePontosPoste: 0,
        Id: ''
	});

	useEffect(() => {
		recuperarParametros();
		recuperarCidadePadrao();
	}, [mapaLoaded]);

	async function recuperarParametros() {
		try {
			const response = await servConsultaDisponibilidade.BuscarParametros();
			
			if(response && response.Content.length) {
				setParametros(response.Content[0]);
			}
		}
		catch (err) {
			console.log(err);
		}
	}

	async function recuperarCidadePadrao() {
		try {
			const response = await servLogin.recuperarCidadePadrao();

			if (response?.Success) {
				const data = {
					lat: response.Content?.Latitude || -23.550520,
					lng: response.Content?.Longitude || -46.633309,
				};

				setCoordenadasLatLong(data);
				setShowDrawing(true);
			}
		}
		catch (err) {
			console.log(err);
		}
	}

	return (
		<div
			style={{
				position: "absolute",
				top: "64px",
				left: drawerWidth,
				right: "0",
				bottom: "0",
				zIndex: 1,
				transition: "left 0.3s ease"
			}}
		>
			{showMenssage && <div
				style={{
					position: "absolute",
					top: "20px",
					left: "50%",
					transform: "translateX(-50%)",
					backgroundColor: "rgba(52, 52, 52, 0.8)",
					color: "white",
					padding: "10px 16px",
					borderRadius: "8px",
					fontSize: "14px",
					zIndex: 5,
					boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
				}}
			>
				Selecione a área desejada no mapa e clique em <strong>Consultar disponibilidade</strong>.

				<button style={{
					background: "none",
					marginLeft: "14px",
					border: "none",
					color: "white",
					cursor: "pointer",
					fontSize: "14px",
					transition: "color 0.3s ease",
					":hover": {
						color: "#ccc"
					}
				}} onClick={() => setShowMenssage(false)}>
					<FontAwesomeIcon icon={faClose} />
				</button>
			</div>}

			<MapaDrawing
				parametros={parametros}
				coordenadasLatLong={coordenadasLatLong}
				showDrawing={showDrawing}
				setCoordenadasLatLong={setCoordenadasLatLong}
				mapaLoaded={mapaLoaded}
				setMapaLoaded={setMapaLoaded}
				containerStyle={{ width: '100%', height: '100%' }}
			/>
		</div>
	);
}

export { ConsultaDisponibilidade }